<template lang="pug">
.integration-actions.flex
  div(
    v-for="(action, i) in actions"
    :key="i"
  )
    IntegrationImageButton(
      v-if="actionHasImage(action)"
      :action="action"
      @click="performAction(action)"
      :data-test-id="testId(action.ActionCode)"
      )
    BriqButton.mr-XXS(
      v-else 
      @click="performAction(action)"
      :disabled="isLoading"
      :data-test-id="testId(action.ActionCode)"
      ) {{ action.ActionName }}
</template>

<script>
import { mapActions } from 'vuex'
import IntegrationImageButton from '@/vue/settings/application/integrations/IntegrationsModal/IntegrationImageButton.vue'
import IntegrationActionType from '@v/models/IntegrationActionTypesEnum.js'
import toKebab from '@/helpers/toKebab.js'

export default {
  name: 'IntegrationActions',
  components: { IntegrationImageButton },
  props: {
    actions: Array,
    identificationCode: String,
  },
  data() {
    return {
      isLoading: false,
    }
  },
  methods: {
    ...mapActions('integrations', ['performIntegrationAction']),
    testId(actionCode) {
      return `action-button-${toKebab(actionCode)}`
    },
    async performAction(action) {
      this.isLoading = true
      const model = {
        ReturnURL: `${this.$window.location.protocol}//${this.$window.location.host}${this.$router.currentRoute.fullPath}?open=${this.identificationCode}`,
      }
      try {
        const response = await this.performIntegrationAction({
          identificationCode: this.identificationCode,
          actionCode: action.ActionCode,
          model,
        })
        switch (response.data.ActionType) {
          case IntegrationActionType.Direct:
            this.$notifySuccess('Action succeeded')
            break
          case IntegrationActionType.OnewayRedirect:
            this.$window.open(response.data.RedirectUrl, '_blank')
            break
          case IntegrationActionType.RoundTripRedirect:
            this.$window.location.replace(response.data.RedirectUrl)
            break
        }
        if (response.data.PerformRefresh) this.$emit('performRefetch')
      } catch (e) {
        this.$notifyError('Unable to perform integration action')
      }
      this.isLoading = false
    },
    actionHasImage(action) {
      return action.ImageNormal !== null
    },
  },
}
</script>

<style scoped lang="stylus"></style>
